import React from "react";

const ASP_TextStream = () => {
  return (
    <div className="tutorial-page">
      <h1>ASP TextStream</h1>
      <p>This is the ASP TextStream page content.</p>
    </div>
  );
};

export default ASP_TextStream;
